import { Injectable, inject } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { map } from 'rxjs/operators';
@Injectable()
export class LoginEffects {
	private actions$ = inject(Actions);

	loginSuccess$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType('[Login] Login Success'),
				map((response) => ({ type: '[Login] Login Success', payload: response }))
			),
		{ dispatch: false }
	);

	loginError$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType('[Login] Login Error'),
				map((response) => ({ type: '[Login] Login Error', payload: response }), { dispatch: false })
			),
		{ dispatch: false }
	);


	constructor() {}
}
